import React, { useCallback, useEffect, useMemo, useState } from "react";
import DataTable from "react-data-table-component";
import { customStyles } from "../Utility/Utility";
import { AddUpdate } from "../../../ApiMethods/ApiMethods";
import { Modal } from "react-bootstrap";
import swal from "sweetalert";

const TopicWiseNotification = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [postModal, setPostModal] = useState(false);
  const [saving, setSaving] = useState(false);
  const [addFormData, setAddFormData] = useState({
    Topic: "",
    TopicCategory: "",
    Title: "",
    Body: "",
    ImageFile: null,
    CreatedByUser: "",
  });
  const [categories, setCategories] = useState([]);
  const [topicsDrop, setTopicsDrop] = useState([]);

  const fetchData = useCallback(async (signal) => {
    setLoading(true);
    setError(null);
    try {
      const response = await AddUpdate(
        "Notifications/GetData_NotificationSend",
        {},
      );
      if (signal?.aborted) return;
      const parsed = JSON.parse(response?.data?.data || "{}");
      const rows = parsed?.Table || [];
      setData(rows);
    } catch (err) {
      if (signal?.aborted) return;
      console.error("Error fetching notifications:", err);
      setError("Failed to load notifications");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    const controller = { aborted: false };
    fetchData(controller);
    fetchCategories();
    fetchTopics();
    return () => {
      controller.aborted = true;
    };
  }, [fetchData]);

  const fetchCategories = async () => {
    try {
      const response = await AddUpdate("NotificationCondition/GetData_TopicwiseCategory", { IsActive: 1 });
      const parsed = JSON.parse(response?.data?.data || "{}");
      setCategories(parsed?.Table || []);
     
    } catch (err) {
      console.error("Error fetching categories:", err);
      setCategories([]);
    }
  };

  const fetchTopics = async (categoryId) => {
    try {
      const payload = {  };
      if (categoryId) payload.CategoryID = categoryId;
      const response = await AddUpdate("NotificationCondition/GetDropDownTopic", payload);
      const parsed = JSON.parse(response?.data?.data || "{}");
      setTopicsDrop(parsed?.Table || []);
    } catch (err) {
      console.error("Error fetching topics dropdown:", err);
      setTopicsDrop([]);
    }
  };

  const columns = useMemo(
    () => [
      { name: "Topic", selector: (row) => row.Topic, sortable: true },
      { name: "Title", selector: (row) => row.Title, sortable: true },
      {
        name: "Body",
        selector: (row) => row.Body,
        sortable: false,
        wrap: true,
      },
    ],
    [],
  );
  
  const filteredTopics = useMemo(() => {
    if (!addFormData.TopicCategory) return topicsDrop || [];
    return (topicsDrop || []).filter((item) => {
      const cat = item.TopicCategory || item.CategoryName || item.Category || item.TopicCategoryName || item.Category || item.CategoryId;
      const catVal = String(cat || "");
      return catVal === String(addFormData.TopicCategory);
    });
  }, [topicsDrop, addFormData.TopicCategory]);

  const resetForm = useCallback(() => {
    setAddFormData({
      Topic: "",
      TopicCategory: "",
      Title: "",
      Body: "",
      ImageFile: null,
      CreatedByUser: "",
    });
  }, []);

  const handleAddFormSubmit = useCallback(
    async (e) => {
      e.preventDefault();
      if (!addFormData.Topic?.trim()) {
        swal("Validation", "Topic is required", "warning");
        return;
      }
      setSaving(true);
      try {
        const formData = new FormData();
        formData.append("Topic", addFormData.Topic.trim());
        formData.append("TopicCategory", addFormData.TopicCategory || "");
        formData.append("Title", addFormData.Title?.trim() || "");
        formData.append("Body", addFormData.Body?.trim() || "");
        if (addFormData.ImageFile)
          formData.append("ImageUrl", addFormData.ImageFile);
        formData.append("CreatedByUser", 1);
        formData.append(
          "Data",
          JSON.stringify({
            Topic: addFormData.Topic.trim(),
            // TopicCategory: addFormData.TopicCategory || "",
            Title: addFormData.Title?.trim() || "",
            Body: addFormData.Body?.trim() || "",
            CreatedByUser: 1,
          }),
        );
        const response = await AddUpdate(
          "Notifications/Insert_Notificationsend",
          formData,
        );
        if (response) {
          swal("Success", "Notification added", "success");
          setPostModal(false);
          resetForm();
          fetchData();
        }
      } catch (err) {
        console.error("Error adding notification:", err);
        swal("Error", "Could not add notification", "error");
      } finally {
        setSaving(false);
      }
    },
    [addFormData, fetchData, resetForm],
  );

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center">
        <h2 className="text-warning fw-bold">Topic Wise Notification</h2>
        <button className="btn btn-primary" onClick={() => setPostModal(true)}>
          Add Topic Notification
        </button>
      </div>

      <div className="col-12 mt-2">
        <DataTable
          dense
          data={data}
          columns={columns}
          selectableRowsHighlight
          highlightOnHover
          pagination
          fixedHeader
          customStyles={customStyles}
          persistTableHead
          noDataComponent={
            loading ? "Loading..." : "There are no data to display"
          }
        />
        {error && <div className="text-danger mt-2">{error}</div>}
      </div>

      <Modal
        show={postModal}
        onHide={() => setPostModal(false)}
        backdrop="static"
      >
        <form onSubmit={handleAddFormSubmit}>
          <div className="modal-header">
            <h4 className="modal-title fs-20">Add Topic Notification</h4>
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={() => {
                setPostModal(false);
                resetForm();
              }}
            />
          </div>

          <div className="modal-body p-3">
            <div className="form-group">
              <label className="form-label">Category</label>
              <select
                className="form-select"
                value={addFormData.TopicCategory}
                onChange={(e) => {
                  const val = e.target.value;
                  setAddFormData({ ...addFormData, TopicCategory: val, Topic: "" });
                  // fetch topics filtered by selected category id (or all if empty)
                  fetchTopics(val || undefined);
                }}
                disabled={saving}
              >
                <option value="">All Categories</option>
                  {categories?.map((item, idx) => {
                    const id = item.Id || item.CategoryID || item.CategoryId || item.Value || item.Name;
                    const label = item.TopicwiseCategory || item.DisplayName || item.CategoryName || item.Category || item.Value || item.Name || String(id);
                    return (
                      <option key={idx} value={id}>
                        {label}
                      </option>
                    );
                  })}
              </select>
            </div>

            <div className="form-group mt-2">
              <label className="form-label">
                Topic <span className="text-danger">*</span>
              </label>
              <select
                className="form-select"
                name="Topic"
                value={addFormData.Topic}
                onChange={(e) =>
                  setAddFormData({ ...addFormData, Topic: e.target.value })
                }
                disabled={saving}
                required
              >
                <option value="">Select Topic</option>
                {(topicsDrop || []).map((item, index) => {
                  const value = item.Topic || item.TopicName || item.Name || item.Value || item.Id;
                  const label = item.Topic || item.TopicName || item.DisplayName || item.Name || String(item.Id);
                  return (
                    <option key={index} value={value}>
                      {label}
                    </option>
                  );
                })}
              </select>
            </div>

            <div className="form-group mt-2">
              <label className="form-label">Title</label>
              <input
                type="text"
                className="form-control"
                name="Title"
                value={addFormData.Title}
                onChange={(e) =>
                  setAddFormData({ ...addFormData, Title: e.target.value })
                }
                placeholder="Enter title"
                disabled={saving}
              />
            </div>

            <div className="form-group mt-2">
              <label className="form-label">Body</label>
              <textarea
                className="form-control"
                rows={4}
                name="Body"
                value={addFormData.Body}
                onChange={(e) =>
                  setAddFormData({ ...addFormData, Body: e.target.value })
                }
                placeholder="Enter body"
                disabled={saving}
              />
            </div>

            <div className="form-group mt-2">
              <label className="form-label">Image (upload)</label>
              <input
                type="file"
                accept="image/*"
                className="form-control"
                name="ImageFile"
                onChange={(e) =>
                  setAddFormData({
                    ...addFormData,
                    ImageFile:
                      e.target.files && e.target.files[0]
                        ? e.target.files[0]
                        : null,
                  })
                }
                disabled={saving}
              />
              {addFormData.ImageFile && (
                <div className="mt-2">
                  <small>Selected: {addFormData.ImageFile.name}</small>
                </div>
              )}
            </div>
          </div>
          <div className="modal-footer">
            <button type="submit" className="btn btn-primary" disabled={saving}>
              {saving ? "Saving..." : "Save"}
            </button>
            <button
              type="button"
              onClick={() => {
                setPostModal(false);
                resetForm();
              }}
              className="btn btn-danger"
            >
              Close
            </button>
          </div>
        </form>
      </Modal>
    </div>
  );
};

export default TopicWiseNotification;
